<template>
  <div class="flex flex-col h-full">
    <div
      class="flex justify-between items-center border-b border-gray-200 py-5 px-16"
    >
      <p
        @click="activeView = 'subCommunities'"
        class="font-bold text-lg cursor-pointer"
      >
        <icon name="users" class="mr-2" />{{ $t('settings.manageSubCommunities.title') }} ({{
          subIssuersCount
        }})
      </p>
    </div>
    <div v-if="activeView == 'subCommunities'" class="py-8 px-16">
      <div class="w-full bg-white border shadow-sm rounded-lg mb-32 p-8">
        <div class="flex items-center justify-between mb-10">
          <div class="w-[40%] relative">
            <input
              type="text"
              :placeholder="$t('settings.manageSubCommunities.searchPlaceholder')"
              class="w-full h-10 outline-none text-sm rounded-lg border border-gray-200 opacity-50 py-6 pl-10 pr-10"
              v-model="issuerSearch"
              maxlength="50"
            />
            <icon
              name="magnifying-glass"
              class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-50 fill-gray-500"
            />
          </div>
          <div class="flex items-center gap-4">
            <!-- <button
              @click="exportSubIssuers()"
              class="flex items-center gap-2 h-9 text-sm border border-gray-200 shadow-sm rounded-lg pl-3 pr-4 cursor-pointer"
            >
              <icon name="download" class="w-5 h-5 fill-gray-600" />
              <p class="text-sm">Export</p>
            </button> -->
            <button
              @click="activeView = 'addSubCommunity'"
              class="flex items-center gap-2 bg-secondary h-9 text-sm text-white shadow-sm rounded-lg pl-3 pr-4 cursor-pointer"
            >
              <icon name="user-add" class="w-5 h-5 fill-white" />
              <p class="text-sm">{{ $t('settings.manageSubCommunities.addSubCommunity') }}</p>
            </button>
          </div>
        </div>
        <div class="flex flex-col border border-gray-200 rounded-lg">
          <div class="flex items-center border-b border-gray-200 py-2">
            <div class="w-[25%] p-3">
              <p class="font-medium pl-3">{{ $t('settings.manageSubCommunities.community') }}</p>
            </div>
            <div class="w-[20%] p-3">
              <p class="font-medium pl-3">{{ $t('settings.manageSubCommunities.email') }}</p>
            </div>
            <div class="w-[10%] p-3">
              <p class="font-medium">{{ $t('settings.manageSubCommunities.members') }}</p>
            </div>
            <div class="w-[10%] p-3">
              <p class="font-medium">{{ $t('settings.manageSubCommunities.badges') }}</p>
            </div>
            <div class="w-[15%] p-3">
              <p class="font-medium">{{ $t('settings.manageSubCommunities.creation') }}</p>
            </div>
            <div class="w-[10%] p-3">
              <p class="font-medium">{{ $t('settings.manageSubCommunities.status') }}</p>
            </div>
            <div class="w-[10%] p-3">
              <p class="font-medium">{{ $t('settings.manageSubCommunities.actions') }}</p>
            </div>
          </div>
          <div
            v-if="!loading"
            v-for="(subIssuer, index) in subIssuers"
            :key="subIssuer.did"
            class="flex items-center border-b border-gray-200 py-2"
            :class="{
              'border-b-0': index == subIssuers.length - 1,
            }"
          >
            <div
              @click="switchSubIssuer(subIssuer.did)"
              class="w-[25%] flex items-center gap-2 p-3 cursor-pointer"
              :class="{
                'pointer-events-none': subIssuer.state == 'pending',
              }"
            >
              <img
                :src="
                  subIssuer.profileImage
                    ? subIssuer.profileImage
                    : require('/assets/images/blank-profile-avatar.png')
                "
                class="w-10 h-10 rounded-full"
              />
              <p class="pl-2 break-all">{{ subIssuer.name }}</p>
            </div>
            <div class="w-[20%] p-3">
              <p class="">{{ subIssuer.adminEmail }}</p>
            </div>
            <div class="w-[10%] p-3">
              <p class="">{{ subIssuer.membersCount }}</p>
            </div>
            <div class="w-[10%] p-3">
              <p class="pl-3">{{ subIssuer.badgesCount }}</p>
            </div>
            <div class="w-[15%] p-3">
              <p class="">
                {{
                  new Date(subIssuer.created).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                  })
                }}
              </p>
            </div>
            <div class="w-[10%] p-3">
              <p v-if="subIssuer.state == 'pending'" class="text-blue-500">
                Pending
              </p>
              <p v-else class="pl-2">
                <icon name="check" class="w-7 h-7 fill-blue-400" />
              </p>
            </div>
            <div class="w-[10%] flex items-center gap-4 p-3">
              <div
                @click="getSubIssuers()"
                class="w-9 h-9 flex items-center justify-center border border-gray-200 rounded-lg cursor-pointer"
              >
                <icon name="refresh" class="w-4 h-4 fill-gray-500" />
              </div>
            </div>
          </div>
          <div
            v-if="!loading && subIssuers.length == 0"
            class="flex items-center p-4"
          >
            <p class="text-gray-500 text-sm">{{ $t('settings.manageSubCommunities.noSubCommunities') }}</p>
          </div>
          <div v-if="loading" class="flex items-center p-10">
            <Vue3Lottie
              :animationLink="require('/assets/images/loader-round.jpg')"
              :height="50"
              :width="50"
              :speed="1.5"
            />
          </div>
        </div>
        <div class="flex items-center justify-between mt-5">
          <p class="text-sm text-gray-500">
            <span class="font-bold text-blue-500">{{ currentPage }}</span> {{ $t('settings.manageSubCommunities.of') }}
            {{ totalPages }} {{ $t('settings.manageSubCommunities.pages') }}
          </p>
          <div class="flex items-center gap-2">
            <div class="flex items-center gap-2 mr-2">
              <p class="text-sm text-gray-500">{{ $t('settings.manageSubCommunities.pageOn') }}</p>
              <select
                v-model="currentPage"
                class="w-14 h-9 px-2 text-sm leading-none border border-gray-200 rounded-lg cursor-pointer text-gray-500"
                @change="getSubIssuers()"
              >
                <option v-for="page in totalPages" :key="page" :value="page">
                  {{ page }}
                </option>
              </select>
            </div>
            <div
              class="w-9 h-9 flex items-center justify-center border border-gray-200 rounded-lg cursor-pointer"
              @click="changePage(false)"
            >
              <icon name="chevron-left" class="w-5 h-5 fill-gray-500" />
            </div>
            <div
              class="w-9 h-9 flex items-center justify-center border border-gray-200 rounded-lg cursor-pointer"
              @click="changePage(true)"
            >
              <icon
                name="chevron-left"
                class="w-5 h-5 fill-gray-500 rotate-180"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="activeView == 'addSubIssuer'" class="py-8 px-16">
      <div class="w-full bg-white border shadow-sm rounded-lg mb-32 p-8">
        <p class="font-bold text-lg">Add sub-community</p>
      </div>
    </div>
    <div v-if="activeView == 'addSubCommunity'" class="py-8 px-16">
      <div class="w-full bg-white border shadow-sm rounded-lg mb-32 p-8">
        <p class="font-bold text-lg mb-2">{{ $t('settings.manageSubCommunities.addNewSubCommunity') }}</p>
        <p>{{ $t('settings.manageSubCommunities.fillDetails') }}</p>
        <div class="flex flex-col gap-3 mt-16 mb-8">
          <div
            v-for="(subCommunity, index) in subCommunitiesToInvite"
            :key="index"
            class="flex gap-3"
          >
            <div class="w-[3%] flex items-center justify-center">
              <div
                class="w-full flex items-center justify-center border border-gray-300 text-gray-400 bg-gray-100 aspect-square rounded-full"
              >
                {{ index + 1 }}
              </div>
            </div>
            <input
              type="text"
              :placeholder="$t('settings.manageSubCommunities.communityName')"
              class="w-[24%] h-10 text-sm outline-none rounded-lg border border-gray-200 py-6 px-4 pr-10"
              v-model="subCommunity.name"
              maxlength="50"
            />
            <input
              type="text"
              :placeholder="$t('settings.manageSubCommunities.emailAddress')"
              class="w-[23%] h-10 text-sm outline-none rounded-lg border border-gray-200 py-6 px-4 pr-10"
              v-model="subCommunity.email"
              maxlength="50"
            />
            <input
              type="text"
              :placeholder="$t('settings.manageSubCommunities.firstName')"
              class="w-[23%] h-10 text-sm outline-none rounded-lg border border-gray-200 py-6 px-4 pr-10"
              v-model="subCommunity.firstName"
              maxlength="50"
            />
            <input
              type="text"
              :placeholder="$t('settings.manageSubCommunities.lastName')"
              class="w-[23%] h-10 text-sm outline-none rounded-lg border border-gray-200 py-6 px-4 pr-10"
              v-model="subCommunity.lastName"
              maxlength="50"
            />
            <div
              @click="removeSubCommunity(index)"
              class="w-[4%] flex items-center justify-center border border-gray-200 rounded-lg cursor-pointer"
            >
              <icon name="trash" class="w-5 h-5 fill-gray-500" />
            </div>
          </div>
          <p
            @click="addSubCommunity()"
            class="text-blue-500 font-medium cursor-pointer ml-10"
          >
            <icon name="plus" class="fill-blue-500 w-4 mr-3" />{{ $t('settings.manageSubCommunities.addCommunity') }}
          </p>
        </div>

        <div class="flex justify-center">
          <button
            @click="sendInvitation"
            class="bg-secondary text-white shadow-sm font-medium rounded-lg px-12 py-2 cursor-pointer"
          >
            {{ $t('settings.manageSubCommunities.send') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { computed, ref, inject, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import jwt from 'jsonwebtoken';
import BasicSmModal from '../../components/BasicSmModal.vue';
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const utils = inject('utils');
    const api = inject('api');
    const cookies = inject('cookies');
    const { t } = useI18n();

    const activeView = ref('subCommunities');
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalPages = ref(0);
    const totalCount = ref(0);
    const issuerSearch = ref('');

    const subIssuers = ref([]);
    const subIssuersCount = ref(0);
    const subCommunitiesToInvite = ref([
      {
        name: '',
        email: '',
        firstName: '',
        lastName: '',
      },
    ]);
    const loading = ref(false);

    watch(issuerSearch, () => {
      getSubIssuers();
    });

    async function getSubIssuers() {
      loading.value = true;
      const subIssuerData = (
        await api.getSubIssuers(
          currentPage.value,
          pageSize.value,
          issuerSearch.value
        )
      ).data;
      subIssuers.value = subIssuerData.issuers;
      subIssuersCount.value = subIssuerData.pagination.totalCount;
      totalPages.value = subIssuerData.pagination.totalPages;
      loading.value = false;
    }
    getSubIssuers();

    async function changePage(direction) {
      if (direction && currentPage.value < totalPages.value) {
        currentPage.value++;
        getSubIssuers();
      } else if (!direction && currentPage.value > 1) {
        currentPage.value--;
        getSubIssuers();
      }
    }

    async function switchSubIssuer(did) {
      api.switchSubIssuer(did).then((res) => {
        const { token: subToken } = res.data;

        const token = cookies.get('token');
        cookies.set('token', subToken);
        cookies.set('adminToken', token);
        cookies.set('adminProfile', JSON.stringify(currentIssuerInfo.value));

        const decodedToken = jwt.decode(subToken);
        // restore global session
        store.commit('setCurrentIssuerDid', decodedToken.did);
        store.commit('setCurrentAddress', utils.didToAddress(decodedToken.did));
        store.commit('setIsWeb2Connexion', decodedToken.web2);
        store.commit('setConnexionEmail', decodedToken.connexionEmail);
        store.commit('setIsAdmin', !decodedToken.isContributor);
        store.dispatch('getTemplateLists');
        store.dispatch('getIssuerInfo');

        router.push('/');
      });
    }

    async function sendInvitation() {
      // if there is an empty field subCommunity, remove it
      subCommunitiesToInvite.value = subCommunitiesToInvite.value.filter(
        (subCommunity) =>
          subCommunity.name !== '' &&
          subCommunity.email !== '' &&
          subCommunity.firstName !== '' &&
          subCommunity.lastName !== ''
      );

      // // check if all fields are filled for each subCommunity
      // const allFieldsFilled = subCommunitiesToInvite.value.every(
      //   (subCommunity) =>
      //     /^.{3,50}$/.test(subCommunity.name) &&
      //     /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(subCommunity.email) &&
      //     /^.{3,50}$/.test(subCommunity.firstName) &&
      //     /^.{3,50}$/.test(subCommunity.lastName)
      // );

      // if (!allFieldsFilled) {
      //   utils.showToastMessageError(t('settings.manageSubCommunities.fillFieldsCorrectly'));
      //   return;
      // }

      api.sendSubManagerInvitation(subCommunitiesToInvite.value).then((res) => {
        subCommunitiesToInvite.value = [
          {
            name: '',
            email: '',
            firstName: '',
            lastName: '',
          },
        ];

        getSubIssuers();
        activeView.value = 'subCommunities';

        utils.showToastMessageSuccess(t('settings.manageSubCommunities.invitationsSent'));
      });
    }

    function addSubCommunity() {
      subCommunitiesToInvite.value.push({
        name: '',
        email: '',
        firstName: '',
        lastName: '',
      });
    }

    function removeSubCommunity(index) {
      subCommunitiesToInvite.value.splice(index, 1);
    }

    return {
      subIssuers,
      subIssuersCount,
      currentPage,
      pageSize,
      totalPages,
      totalCount,
      changePage,
      getSubIssuers,
      issuerSearch,
      switchSubIssuer,
      loading,
      activeView,
      subCommunitiesToInvite,
      addSubCommunity,
      removeSubCommunity,
      sendInvitation,
    };
  },
  components: {
    BasicSmModal,
  },
};
</script>
